import React from 'react';
import alertify from 'alertifyjs';

import {getUserId} from 'utils/authentication';
import Track from 'utils/tracker';
import API, {handleError} from 'utils/xhr';


export class ModalFeedback extends React.Component {

  state = {
    data: {
      user_id_type: (getUserId())? 'user_xid': 'email',
      user_id: (getUserId())? getUserId(): '',
      feedback: '',
    }
  }

  onChange(e){
    e.preventDefault();

    const state = this.state;
    state.data[e.target.name] = e.target.value;
    this.setState(state);
  }

  onModalClick(e){
    Track.event('modal_click', e.target.name);
  }

  onSubmit(e){
    e.preventDefault();

    if (this.state.data.user_id === ''){
      alertify.warning("Email cannot be Empty!", 1.5);
      return;
    }
    
    const url = '/public/feedback';
    const data = this.state.data;
    API.post(url, data).then(response =>{
      const state = this.state;
      state.data = {
        user_id_type: 'email',
        user_id: '',
        feedback: '',
      };
      this.setState(state);
      alertify.success("Feedback Submitted!", 1.5);
    },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }

  render (){

    const modalID = this.props.modalID;
    const modalTitle = this.props.modalTitle;
    const modalLinkText = this.props.modalLinkText;

    return (
      <div className="pull-right">
        <a href="/" className={""} name={modalID} data-toggle="modal" data-target={"#"+modalID} onClick={this.onModalClick.bind(this)}>{modalLinkText}</a>
        <div className="modal box-shadow" id={modalID}>
          <div className="modal-dialog" role="document">
            <div className="modal-content rounded" style={{border: '0px'}}>
              <div className="modal-header bg-quaternary text-white">
                <h5 className="modal-title">Feedback on {modalTitle}</h5>
                <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">

                {(getUserId())? (''): (
                  <div className="form-group">
                    <label className="text-muted">Your email address:</label>
                    <input 
                      type="email" 
                      className="form-control" 
                      name="user_id"
                      onChange={this.onChange.bind(this)}
                      value={this.state.data.user_id}
                      placeholder="Enter email" />
                    {/* <small className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                  </div>
                )}

                <div className="form-group">
                  <label className="text-muted">Your Feedback / Question:</label>
                  <textarea 
                    className="form-control" 
                    name="feedback"
                    onChange={this.onChange.bind(this)}
                    value={this.state.data.feedback}
                    rows="5"></textarea>
                </div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-quaternary text-white" onClick={this.onSubmit.bind(this)}>Submit</button>
                <button type="button" className="btn btn-primary" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}